/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails, setSubscibe } from "../../../store/user.store";
import LoadingComponent from "../../LoadingComponent";
import { fireGtagEvent } from "../../../utils/google-analytics";
import freeShippingIcon from "../../../assets/free-shippingIcon.svg";
import { ErrorTemplate } from "../../../templates";

export default function PhoneTemplate({ otpStatus, sendOtpToUser }) {
  const dispatch = useDispatch();
  const { subscribe: defaultSubscribe } = useSelector((state) => state.user);
  const { shopifyCart, cartDetails } = useSelector((state) => state.cart);
  const [error, setError] = useState("");
  const [subscribe, setSubscibeModel] = useState(defaultSubscribe);
  const [phoneNumber, setPhoneNumber] = useState();
  const phoneNumberRegex = /^[56789]\d{9}$/g;

  const sendOTP = () => {
    setError(null);
    if (!phoneNumberRegex.test(phoneNumber)) {
      return setError("Phone number is invalid!");
    }

    fireGtagEvent("phone_no_added");
    dispatch(setSubscibe({ subscribe }));
    dispatch(setUserDetails({ phoneNumber }));
    return sendOtpToUser();
  };

  const handleChange = (e) => {
    setPhoneNumber(e.target.value);
  };
  if (!shopifyCart) {
    return (
      <div className="phone-number">
        <LoadingComponent height="64vh" />
      </div>
    );
  }

  const handleMaxLength = (e) => {
    if (phoneNumber?.length >= 10 && e.key !== "Backspace") {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      sendOTP();
    }
  };

  const handleCheckbox = (e) => {
    setSubscibeModel(e.target.checked);
  };

  return (
    <div>
      <div className="phone-number">
        <div className="enter">
          <h2 className="heading2">Enter Phone Number</h2>
          <div className="phone-number-box">
            <h2>+91 -</h2>
            <input
              type="number"
              value={phoneNumber}
              maxLength={10}
              onKeyDown={handleMaxLength}
              onChange={handleChange}
              id="mobile-number"
            />
          </div>
        </div>
        <ErrorTemplate error={error} />
        <div className="notify">
          <input
            type="checkbox"
            checked={!!subscribe}
            onChange={handleCheckbox}
          />
          <p>Notify me for order updates & offers over Whatsapp</p>
        </div>
      </div>
      {cartDetails.finalAmount < 500 && (
        <div className="free-shipping-mobile">
          <div>
            <img src={freeShippingIcon} alt="" />
          </div>
          <div className="free-shipping-text-mobile">
            <h1>Free Shipping</h1>
            <p>on all order above Rs.499</p>
          </div>
        </div>
      )}
      <div className="bottom-btn">
        {otpStatus === "pending" ? (
          <button type="button" className="btn" aria-label="loading">
            <LoadingComponent diameter="30" color="#ffffff" />
          </button>
        ) : (
          <button className="btn" type="button" onClick={sendOTP}>
            Continue
          </button>
        )}
      </div>
    </div>
  );
}
